import { useEffect, useState } from "react";

/**
 * The current instant, re-read on a timer.
 *
 * For a clock or a countdown the page has to move on its own; nothing else on
 * a Home screen does. Kept as a hook so the tick is confined to the component
 * that shows the time rather than re-rendering the whole page every second.
 */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
